import React, { Component } from "react";
import {
  HashRouter as Router,
  Route,
  withRouter
} from "react-router-dom";

import About from "./components/About";
import HowToPlay from "./components/HowToPlay";
import Disclaimer from "./components/Disclaimer";
import SelectQuiz from "./components/SelectQuiz";
import Quiz from "./components/Quiz";
import End from "./components/End";
import Title from "./components/Title";

import "./styles/App.css";

const BingoWithRouter = withRouter(({ history }) => (
  <Quiz
    endGame={() => {
      history.push("/end");
    }}
  />
));

class App extends Component {
    
  constructor(props) {
    super(props);
    this.state = {height: props.height};
    this.state = {width: props.width};
  }

  componentWillMount(){
    this.setState({height: window.innerHeight + 'px'});
    this.setState({width: window.innerWidth + 'px'});
  }

  render() {
    return (
      <Router>
        <React.Fragment>
          <Route exact path="/" component={Title} />
          <Route path="/about" component={About} />
          <Route path="/howtoplay" component={HowToPlay} />
          <Route path="/disclaimer" component={Disclaimer} />
          <Route path="/selectQuiz" component={SelectQuiz} />
          <Route path="/quiz" component={Quiz} />
          <Route path="/end" component={End} />
        </React.Fragment>
      </Router>
    );
  }
}

export default App;
